import React from 'react'
import classNames from "classnames";

import { HippoComponentProps } from "..";

import IconButton from "../IconButton/IconButton";

import styles from './Toast.module.scss';

export interface Props extends HippoComponentProps {
  headerIconComponent?: React.ReactNode;
  title?: string;
  content?: string | React.ReactNode;
  leftFooterComponent?: React.ReactNode;
  rightFooterComponent?: React.ReactNode;
  contentType: 'text' | 'advert';
  onClose?: () => void;
  multiline?: boolean;
}

export default function Toast({ className, headerIconComponent, title, content, leftFooterComponent, rightFooterComponent, contentType = 'text', dataQA, onClose, multiline }: Props) {
  return (
    <div data-qa={dataQA} className={classNames(styles.container, className)}>
      {title && <div className={classNames(styles.header, { [styles.multiline]: multiline })}>
        <div className={styles.content}>
          {headerIconComponent && <div className={styles.icon}>{headerIconComponent}</div>}
          <div className={styles.title}>{title}</div>
        </div>
        {onClose &&
          <div className={styles.closeButtonContainer}>
            <IconButton
              className={styles.closeButton}
              icon="close"
              size="regular"
              dataQA="close-toast"
              iconSize={24}
              type="primary"
              onClick={onClose}
            />
          </div>
        }
      </div>}
      {content && <div className={classNames({ [styles.advertContent]: contentType === 'advert', [styles.textContent]: contentType === "text" })}>{content}</div>}
      {(leftFooterComponent || rightFooterComponent) && <div className={styles.footer}>{leftFooterComponent && leftFooterComponent}{rightFooterComponent && rightFooterComponent}</div>}
    </div>
  )
}
